// extracted by mini-css-extract-plugin
export default {"navCentre":"Nav_navCentre__Jad4O","active":"Nav_active__HD+Lg"};